import { useSelector } from 'react-redux';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { selectFilters } from '../../Filter/selectors';
import { fetchDocumentsByFilters } from './queries';
import { useDocumentContext } from '../context';
import { buildDocumentsQueryKey } from './useMarkDocumentAsRead';

export function useDocumentsWithPagination() {
  const activeFilters = useSelector(selectFilters);
  const { selectedSegmentId } = useDocumentContext();

  return useQuery({
    queryKey: buildDocumentsQueryKey(activeFilters, selectedSegmentId),
    queryFn: () => fetchDocumentsByFilters(activeFilters, selectedSegmentId),
    placeholderData: keepPreviousData,
    retry: 2,
    retryDelay: 1000,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
